import React, { useState } from "react";

import emp001 from '../../assets/ipmsflowcharts/emp001.png';
import emp002 from '../../assets/ipmsflowcharts/SubmitQuarterPerformances.png';
import emp003 from '../../assets/ipmsflowcharts/SubmitFinalAssessment.png';
import emp004 from '../../assets/ipmsflowcharts/QuarterPerformancesApproval.png'
import emp005 from '../../assets/ipmsflowcharts/FinalAssessmentApproval.png';
import emp006 from '../../assets/ipmsflowcharts/hr001.png'

const FlowCharts: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className='min-h-screen '>
      <div className='mx-auto bg-white shadow-md rounded-lg px-4'>
        {/* Accordion Item 1 */}
        <div className='border-b border-gray-200'>
          <button
            onClick={() => toggleAccordion(1)}
            className='w-full text-left py-4 text-lg  text-gray-800 flex justify-between items-center'
          >
            Employee
            <span className={`transform ${activeIndex === 1 ? "rotate-180" : ""}`}>▼</span>
          </button>
          {activeIndex === 1 && (
            <div className=' text-gray-600'>
              <div className='my-3'>
                <h2 className='text-md font-semibold border px-3 py-2 text-gray-700 mb-2'>Submit Goals</h2>
                <img src={emp001} alt='' />
              </div>

              <div className='my-3'>
                <h2 className='text-md font-semibold border px-3 py-2 text-gray-700 mb-2'>
                  Submit Quarter Performances (Q1, Q2, Q3, Q4)
                </h2>
                <img src={emp002} alt='' />
              </div>
              <div className='my-3'>
                <h2 className='text-md font-semibold border px-3 py-2 text-gray-700 mb-2'>
                  Submit Final Assessment
                </h2>
                <img src={emp003} alt='' />
              </div>
            </div>
          )}
        </div>

        {/* Accordion Item 2 */}
        <div className='border-b border-gray-200'>
          <button
            onClick={() => toggleAccordion(2)}
            className='w-full text-left py-4 text-lg  text-gray-800 flex justify-between items-center'
          >
            Manager
            <span className={`transform ${activeIndex === 2 ? "rotate-180" : ""}`}>▼</span>
          </button>
          {activeIndex === 2 && (
            <div className=' text-gray-600'>
              <div className='my-3'>
                <h2 className='text-md font-semibold border px-3 py-2 text-gray-700 mb-2'>
                  Quarter Performances Approval (Q1, Q2, Q3, Q4)
                </h2>
                <img src={emp004} alt='' />
              </div>
              <div className='my-3'>
                <h2 className='text-md font-semibold border px-3 py-2 text-gray-700 mb-2'>
                  Final Assessment Approval
                </h2>
                <img src={emp005} alt='' />
              </div>
            </div>
          )}
        </div>

        {/* Accordion Item 3 */}
        <div className='border-b border-gray-200'>
          <button
            onClick={() => toggleAccordion(3)}
            className='w-full text-left py-4 text-lg  text-gray-800 flex justify-between items-center'
          >
            HR Manager
            <span className={`transform ${activeIndex === 3 ? "rotate-180" : ""}`}>▼</span>
          </button>
          {activeIndex === 3 && (
            <div className=' text-gray-600'>
              <div className='my-3'>
                <h2 className='text-md font-semibold border px-3 py-2 text-gray-700 mb-2'>
                  Final Assessment Approval
                </h2>
                <img src={emp006} alt='' />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FlowCharts;
